import dayjs from "dayjs";


const patterns = {
  //Comunidade padrão
  community: {
    name: "Minha comunidade",
    description: "",
    description_links: [],
    type: "CHALLENGE",
    plans: [
      {
        label: "Plano mensal",
        amount: 2490,
        interval: "month",
      },
    ],
    courses: [],
  },

  //Grupo padrão
  group: {
    name: "",
    description: "",
    links: [],
    type: "CHALLENGE",
    interactions_enabled: true,
    interval: {
      start_date: dayjs(new Date()),
      end_date: dayjs(new Date()).add(21, "day"),
    },
    awards: [],
    availability: { plans: null },
    gamification: {
      posts: {
        with_photo: {
          points: 1000,
          daily_limit: 3,
        },
        only_text: {
          points: 20,
          daily_limit: 1,
        },
      },
      activity: {
        points: 1500,
        daily_limit: 2,
      },
      interactions: {
        like: 1,
        comment: 2,
      },
    },
    banner_base64: "",
  },
};


export default patterns
